import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { MoveUpRight, ArrowLeft } from "lucide-react";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "../styles/IJOTPromotions.css"; // Reuse same blue card styling
import "../styles/IJOTIssues.css"; // keep extra issue-specific tweaks

const IJOTIssueDetails = () => {
  const { subid } = useParams();
  const navigate = useNavigate();
  const [issues, setIssues] = useState([]);
  const [issueName, setIssueName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIssues = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}/get-ijot-issues-by-subcategory/${subid}`
        );
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        const apiResponse = await response.json();
        if (!apiResponse.success || !Array.isArray(apiResponse.data))
          throw new Error(apiResponse.message || "Invalid response format");

        setIssues(apiResponse.data);
        if (apiResponse.data[0]?.subid?.subcat)
          setIssueName(apiResponse.data[0].subid.subcat);
      } catch (err) {
        console.error("Error fetching issues:", err);
        setError(`Failed to load issue details: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchIssues();
  }, [subid]);

  return (
    // ✅ Removed excess top margin for compact layout
    <div className="ijot-issue-details-page scrollable-content-home pt-0 ">
      <Container className="py-5">
        {/* Back Button */}
        <div className="d-flex align-items-center mb-4">
          <Button
            variant="outline-secondary"
            className="px-4 py-2 rounded-pill d-flex align-items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={18} />
            Back to Volumes
          </Button>
        </div>

        {/* Header */}
        <div className="text-center mb-5">
          <h2 className="ijot-promotions-heading text-uppercase">
            {issueName || "Issue Details"}
          </h2>
          <p className="text-muted mt-2">
            Access all published articles and PDFs under this issue
          </p>
          <hr className="mx-auto" style={{ width: "180px", opacity: 0.3 }} />
        </div>

        {/* Loading */}
        {loading && (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Loading issue details...</p>
          </div>
        )}

        {/* Error */}
        {error && (
          <div className="alert alert-danger text-center" role="alert">
            {error}
          </div>
        )}

        {/* Grid Layout (Blue Cards) */}
        {!loading && !error && (
          <>
            {issues.length > 0 ? (
              <Row className="g-4">
                {issues.map((item, index) => (
                  <Col xs={12} sm={12} md={6} lg={4} key={item._id || index}>
                    {/* ✅ Blue Card (reusing promotion style) */}
                    <Button
                      className="promo-btn w-100 h-auto p-4 d-flex justify-content-between align-items-center"
                      onClick={() => window.open(item.pdf, "_blank")}
                    >
                      <div className="d-flex align-items-center gap-3 text-start">
                        <MdOutlinePictureAsPdf size={56} className="d-none d-sm-block" />
                        <span className="promo-title">
                          {item.title?.length > 60
                            ? item.title.slice(0, 60) + "..."
                            : item.title}
                        </span>
                      </div>
                      <MoveUpRight size={32} className="d-none d-sm-block" />
                    </Button>
                  </Col>
                ))}
              </Row>
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">No PDFs found for this issue.</p>
              </div>
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default IJOTIssueDetails;
